import './ticket_summary.js.coffee';# Added by Script
class Customer.TicketSummaryCollection extends Backbone.Collection
  model: Customer.TicketSummary

  initialize: (tickets) ->
    super()
    @total = tickets?.length || 0

  countTicketsForUpdate: (attributes) ->
    $.ajax
      url: '/customer/conversations/count_tickets_for_update'
      type: 'POST'
      data:
        conversation_ids: @_getIds()
        conversation: attributes
      success: (response) => @onMassiveUpdateIdsCalculatorJobStarted(response, attributes)

  countTicketsForMassiveUpdate: (filterId, attributes, query) =>
    $.ajax
      url: '/customer/conversations/count_tickets_for_massive_update'
      type: 'POST'
      data:
        filter_id: filterId
        conversation: attributes
        query: query
      success: (response) => @onMassiveUpdateIdsCalculatorJobStarted(response, attributes)

  onMassiveUpdateIdsCalculatorJobStarted: (jobStartResponse, attributes) =>
    @trigger('tickets:update_all:loading') # to unselect all tickets selected
    Backbone.trigger('tickets:update_all:countIds') # to show a noty message
    setTimeout @checkMassiveUpdateIdsCalculatorJob, 5000, jobStartResponse.job_id, attributes

  checkMassiveUpdateIdsCalculatorJob: (jobID, attributes) =>
    $.ajax
      type: 'GET'
      url: "/jobs/#{jobID}/status"
      success: (response) =>
        @onMassiveUpdateIdsCalculatorJobChecked(response.status, response.results, jobID, attributes)
      error: @_displayError

  _displayError: ->
    swal
      title: I18n.t 'generic_error_message'
      type: 'warning'
      closeOnConfirm: true
      confirmButtonText: 'Ok'

  onMassiveUpdateIdsCalculatorJobChecked: (jobStatus, results, jobID, attributes) =>
    switch jobStatus
      when 'completed' then swal({
        title: I18n.t('self_service.massive_update.ids.msg', total: results['ids'].length)
        text: I18n.t('self_service.massive_update.ids.limit')
        type: 'info'
        showCancelButton: true
        confirmButtonClass: 'btn-info'
        confirmButtonText: I18n.t('self_service.massive_update.ids.button_update')
        cancelButtonText: I18n.t('self_service.massive_update.ids.button_cancel')
        closeOnConfirm: true
      }, (isConfirm) =>
        @_massiveUpdateDisplayed(results['ids'], attributes) if isConfirm
      )
      when 'failed', 'killed' then console.error "Async job #{jobID} failed or killed"
      else setTimeout @checkMassiveUpdateIdsCalculatorJob, 5000, jobID, attributes

  _massiveUpdateDisplayed: (ids, attributes) =>
    $.ajax
      url: '/customer/conversations/update_displayed'
      type: 'POST'
      data:
        conversation_ids: ids
        conversation: attributes
      success: @onMassiveUpdateJobStarted

  onMassiveUpdateJobStarted: (jobStartResponse) =>
    Backbone.trigger('tickets:update_all:loading')
    @trigger('tickets:update_all:loading')
    setTimeout @checkMassiveUpdateJob, 5000, jobStartResponse.job_id

  onMassiveUpdateJobChecked: (jobStatus, jobID) =>
    switch jobStatus
      when 'completed' then return
      when 'failed', 'killed' then console.error "Async job #{jobID} failed or killed"
      else setTimeout @checkMassiveUpdateJob, 5000, jobID

  checkMassiveUpdateJob: (jobID) =>
    $.ajax
      url: "/jobs/#{jobID}/status"
      type: 'GET'
      success: (response) => @onMassiveUpdateJobChecked(response.status, jobID)

  unselectAll: (predicate) ->
    predicate ||= (ticket) -> true
    for ticket in @selected()
      ticket.set(selected: false, {silent: true}) if predicate(ticket)

  fetchForExternalTickets: ({ids, success, error}) ->
    $.ajax
      type: 'POST'
      url: '/customer/dashboard/conversations_for_external_tickets'
      data: {conversation_ids: ids}
      datatype: 'json'
      success: (response) =>
        tickets = response.conversations.map((ticketJson) -> new Customer.Ticket(ticketJson, {}))
        @add(tickets)
        success(@)
      error: error

  selectAll: (predicate) ->
    predicate ||= (ticket) -> true
    for ticket in @models
      ticket.set(selected: true, {silent: true}) if predicate(ticket)

  _getIds: ->
    _.pluck(@selected(), 'id')

  selected: ->
    @where(selected: true)

  totalLoaded: ->
    @where()

  toJSON: ->
    @asJson()

  asJson: ->
    _.map(@where(selected: true), (conv) -> conv.toJSON())

  load: ({filter, tags}) ->
    $.ajax
      url: '/customer/dashboard/summaries'
      type: 'POST'
      data: @_buildSummariesData(filter)
      success: (response) => @_processLoad(response, tags)

  _processLoad: (response, tags) =>
    @reset()
    tickets = @_processResponseTickets(response, tags)
    @total = response.total
    @trigger('tickets:loaded', @total, tickets, true)

  loadMore: ({filter, page_number, tags}) ->
    Backbone.trigger 'ui:blocked'
    $.ajax
      url: '/customer/dashboard/next'
      type: 'POST'
      data: _.extend(@_buildSummariesData(filter), page_number: page_number)
      success: (response) => @_processLoadMore(response, tags)

  _buildSummariesData: (filter) ->
    serialized_filter = filter.toJSON()
    return serialized_filter unless filter.isPersisted()

    query = serialized_filter.query
    {
      filter_id: filter.id,
      additional_query: {order_by: query.order_by, search_text: query.search_text, id: query.id}
    }

  _processLoadMore: (response, tags) =>
    return if response.cache_error
    tickets = @_processResponseTickets(response, tags)
    Backbone.trigger 'ui:unblocked'
    @trigger('tickets:loaded', response.total, tickets, false)

  _processResponseTickets: (response, tags) =>
    summaries = (new Customer.TicketSummary(summaryJson, tags) for summaryJson in response.summaries)
    @add summaries
    summaries

  getSocialAccounts: ->
    []

  thereAreMore: ->
    @total > @length
